import { lazy } from "react";
import type { RouteObject } from "react-router-dom";

const HaccpProcessTemplate = lazy(
  () => import("@/pages/haccp/process-template/HaccpProcessTemplate"),
);
const HaccpProcessTemplateLayout = lazy(
  () => import("@/pages/haccp/process-template/HaccpProcessTemplateLayout"),
);
const ProcessTemplateList = lazy(
  () =>
    import(
      "@/pages/haccp/process-template/components/list/ProcessTemplateList"
    ),
);
export const processTemplateRoutes: RouteObject[] = [
  {
    path: "/haccp/process-template",
    element: <HaccpProcessTemplate />,
    children: [
      {
        path: "domain/:domainId/site/:siteId",
        element: <HaccpProcessTemplateLayout />,
        children: [
          {
            path: "",
            element: <ProcessTemplateList />,
          },
        ],
      },
    ],
  },
];
